import { Permiso } from "./Permiso";

export class Perfil {
   public perfilId: string;
   public nombre: string;
   public activo: boolean;
   public permisos: Permiso[];
   public isSuperAdmin: boolean = false;
   public IsPersonalizado: boolean;

   showActions?: boolean;

}
